module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    attrs: {
      "data": _vm.tableData3,
      "border": "",
      "fit": "",
      "width": "100%"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Post info"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Address"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "State",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "city",
      "label": "City",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "Address",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zip",
      "label": "Post",
      "width": "120"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c863b962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tabs/tablecontent.vue
// module id = 764
// module chunks = 2